import { NormalizedCacheObject } from 'apollo-boost';

import {
    acceptFlServiceByFreelancer,
    addFeedbackForFreelancer,
    cancelFlServiceByClient,
    cancelFlServiceByFreelancer,
    deleteFreelancerFeedback,
    requestFlServiceByClient,
    updateFreelancerCardData,
    updateFreelancerFeedback,
    updateFreelancerStatus,
    updateUserPhone
} from '../../graphql/mutations/grid/freelancers';
import {
    AcceptFIServiceByFreelancerMutation,
    AcceptFIServiceByFreelancerMutationVariables,
    AddFeedbackForFreelancerMutation,
    CancelFIServiceByFreelancerMutation,
    CancelFIServiceByFreelancerMutationVariables,
    CancelFlServiceByClientMutation,
    DeleteFreelancerFeedbackMutation,
    GdAddFeedbackForFreelancerRequestInput,
    GdCancelFlServiceByClientRequestInput,
    GdDeleteFreelancerFeedbackRequestInput,
    GdUpdateFreelancerCardItemInput,
    GdUpdateFreelancerFeedbackRequestInput,
    GdUpdateFreelancerSkillItemInput,
    GdUpdateUserPhoneInput,
    RequestFlServiceByClientMutation,
    RequestFlServiceByClientMutationVariables,
    UpdateFreelancerCardMutation,
    UpdateFreelancerFeedbackMutation,
    UpdateFreelancerStatusMutation,
    UpdateFreelancerStatusMutationVariables,
    UpdateUserPhoneMutation
} from '../../typings/graphql-grid';
import { DNAApolloClient } from '../DNAApolloClient/DNAApolloClient';

export class FreelancerMutationExecutor {
    constructor(private client: DNAApolloClient<NormalizedCacheObject>) {}

    public async requestFlServiceByClient(
        variables: RequestFlServiceByClientMutationVariables
    ): Promise<RequestFlServiceByClientMutation> {
        const result = await this.client.mutate<RequestFlServiceByClientMutation>({
            mutation: requestFlServiceByClient,
            variables
        });

        return result.data as RequestFlServiceByClientMutation;
    }

    public async acceptServiceByFreelancer(
        variables: AcceptFIServiceByFreelancerMutationVariables
    ): Promise<AcceptFIServiceByFreelancerMutation> {
        const result = await this.client.mutate<AcceptFIServiceByFreelancerMutation>({
            mutation: acceptFlServiceByFreelancer,
            variables
        });

        return result.data as AcceptFIServiceByFreelancerMutation;
    }

    public async cancelServiceByFreelancer(
        variables: CancelFIServiceByFreelancerMutationVariables
    ): Promise<CancelFIServiceByFreelancerMutation> {
        const result = await this.client.mutate<CancelFIServiceByFreelancerMutation>({
            mutation: cancelFlServiceByFreelancer,
            variables
        });

        return result.data as CancelFIServiceByFreelancerMutation;
    }

    public async cancelFlServiceByClient(
        input: GdCancelFlServiceByClientRequestInput
    ): Promise<CancelFlServiceByClientMutation> {
        const result = await this.client.mutate<CancelFlServiceByClientMutation>({
            mutation: cancelFlServiceByClient,
            variables: {
                input
            }
        });

        return result.data as CancelFlServiceByClientMutation;
    }

    public async addFeedbackForFreelancer(
        input: GdAddFeedbackForFreelancerRequestInput
    ): Promise<AddFeedbackForFreelancerMutation> {
        const result = await this.client.mutate<AddFeedbackForFreelancerMutation>({
            mutation: addFeedbackForFreelancer,
            variables: {
                input
            }
        });

        return result.data as AddFeedbackForFreelancerMutation;
    }

    public async updateFreelancerStatus(
        variables: UpdateFreelancerStatusMutationVariables
    ): Promise<UpdateFreelancerStatusMutation> {
        const result = await this.client.mutate<UpdateFreelancerStatusMutation>({
            mutation: updateFreelancerStatus,
            variables
        });

        return result.data as UpdateFreelancerStatusMutation;
    }

    public async deleteFreelancerFeedback(
        input: GdDeleteFreelancerFeedbackRequestInput
    ): Promise<DeleteFreelancerFeedbackMutation> {
        const result = await this.client.mutate<DeleteFreelancerFeedbackMutation>({
            mutation: deleteFreelancerFeedback,
            variables: {
                input
            }
        });
        return result.data as DeleteFreelancerFeedbackMutation;
    }

    public async updateFreelancerFeedback(
        input: GdUpdateFreelancerFeedbackRequestInput
    ): Promise<UpdateFreelancerFeedbackMutation> {
        const result = await this.client.mutate<UpdateFreelancerFeedbackMutation>({
            mutation: updateFreelancerFeedback,
            variables: {
                input
            }
        });

        return result.data as UpdateFreelancerFeedbackMutation;
    }

    public async updateUserPhone(input: GdUpdateUserPhoneInput): Promise<UpdateUserPhoneMutation> {
        const result = await this.client.mutate<UpdateUserPhoneMutation>({
            mutation: updateUserPhone,
            variables: {
                input
            }
        });

        return result.data as UpdateUserPhoneMutation;
    }

    public async updateFreelancerCard(
        card: GdUpdateFreelancerCardItemInput,
        skills: GdUpdateFreelancerSkillItemInput[],
        regionId: number
    ): Promise<UpdateFreelancerCardMutation> {
        const result = await this.client.mutate<UpdateFreelancerCardMutation>({
            mutation: updateFreelancerCardData,
            variables: {
                commonInput: {
                    card
                },
                skillsInput: {
                    skills
                },
                regionInput: {
                    regionId
                }
            }
        });
        return result.data as UpdateFreelancerCardMutation;
    }
}
